var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6823 30.2878C7.07692 29.1888 2.03174 23.4124 2.03174 16.5078C2.03174 8.82526 8.31745 2.53955 16 2.53955C23.6825 2.53955 29.9682 8.82526 29.9682 16.5078C29.9682 23.4124 24.9146 29.1888 18.3093 30.2878",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3085 30.3684V20.8265C18.3085 20.6862 18.4222 20.5725 18.5624 20.5725L20.9187 20.5725C21.1577 20.5725 21.3644 20.4059 21.4151 20.1724L21.9907 17.5212C22.095 17.0411 21.7243 16.5893 21.233 16.5978L18.3914 16.6467C18.2494 16.6491 18.133 16.5347 18.133 16.3928V14.04C18.133 12.9173 19.0435 12.0074 20.1662 12.0082L21.8409 12.0094C22.1215 12.0096 22.3492 11.7821 22.3492 11.5015V8.66106C22.3492 8.43082 22.1952 8.2289 21.971 8.17668C20.5787 7.85239 17.1859 7.27755 15.3333 8.667C13.3636 10.1443 13.66 14.333 13.6875 16.4016C13.6894 16.5419 13.5757 16.6541 13.4354 16.6541H10.7425C10.4202 16.6541 10.159 16.9154 10.1589 17.2377L10.1587 19.9194C10.1587 20.2801 10.4511 20.5725 10.8118 20.5725L13.4352 20.5725C13.5756 20.5725 13.6893 20.6863 13.6892 20.8267L13.6827 30.3684",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebookDark.f331248ee895c24774e478332da242d0.svg";
export { ForwardRef as ReactComponent };